module.exports = __webpack_public_path__ + "img/icon3.4d5c3bb8.svg";